window._gr_ignore_local_rule = true; // 开启本地页面采集
// eslint-disable-next-line
!(function (e, t, n, g, i) { e[i] = e[i] || function () { (e[i].q = e[i].q || []).push(arguments); }, n = t.createElement("script"), tag = t.getElementsByTagName("script")[0], n.async = 1, n.src = (document.location.protocol == 'https:' ? 'https://' : 'http://') + g, tag.parentNode.insertBefore(n, tag); }(window, document, "script", "assets.giocdn.com/2.1/gio.js", "gio"));
gio('init', '855af400a3d53d24', {});
gio('send');
